import { CommandIcon } from "lucide-react";
import { ILLUSTRATION_COLORS } from "@/constants/values";
import { cn } from "@/components/ui/utils";

export function HotkeysFeature() {
  const { color1, color2 } = ILLUSTRATION_COLORS;
  return {
    left: {
      title: "Hotkeys",
      description:
        "Streamline your workflow with customizable hotkeys & sensible defaults.",
      button: {
        text: "Learn more",
        onClick: () => {},
      },
    },
    center: {
      renderChildren: () => {
        return <>{/* children */}</>;
      },
      backgroundPattern: "dots",
    },
    right: {
      renderChildren: () => {
        return <>{/* children */}</>;
      },
      renderHoverAnimation: (isHovering) => {
        return (
          <>
            {/* Top */}
            <div className="absolute left-8 -top-4 [transition:0.3s_all] w-[51.2px] h-[38.400000000000006px] p-1 [border-width:1px] [border-style:solid] border-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground))] bg-background rounded-sm flex flex-col justify-between items-start shadow-sm">
              <div className="h-1 w-1 rounded-[50%] [transition:0.3s_all] bg-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground)_20%)]" />
              <div className="h-2 w-8 rounded-lg [transition:0.3s_all] bg-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground)_20%)]" />
            </div>
            <div
              className={cn(
                "absolute left-[89.2px] -top-4",
                isHovering ? "transform-[scale(0.9)]" : "transform-[scale(1)]",
                "w-[38.400000000000006px] h-[38.400000000000006px] p-1 [border-width:1px] [border-style:solid] border-[initial]",
                isHovering
                  ? "border-[color-mix(in_srgb,var(--border)_50%,var(--muted-foreground)_50%)]"
                  : "border-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground)_20%)]",
                "rounded-sm bg-background flex items-center justify-center [transition:all_0.3s]",
                isHovering
                  ? "text-[color-mix(in_srgb,var(--border)_50%,var(--muted-foreground)_50%)]"
                  : "text-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground)_20%)]",
                "shadow-sm",
              )}
            >
              A
            </div>
            <div
              // transform: "translateY(-50%)",
              className="absolute left-[133.60000000000002px] -top-4 w-[38.400000000000006px] h-[38.400000000000006px] p-1 [border-width:1px] [border-style:solid] border-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground))] rounded-sm flex items-center justify-center [transition:all_0.3s] bg-background text-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground)_20%)] shadow-sm"
            >
              S
            </div>
            {/* Middle */}
            <div className="absolute left-8 top-[50%] transform-[translateY(-50%)] w-16 h-[38.400000000000006px] p-1 [border-width:1px] [border-style:solid] border-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground))] rounded-sm bg-background text-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground)_20%)] [transition:all_0.3s] flex flex-col justify-end items-start z-100 shadow-sm">
              <div className="h-2 w-8 rounded-lg [transition:0.3s_all] bg-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground)_20%)]" />
            </div>
            <div className="absolute left-25.5 top-[50%] transform-[translateY(-50%)] w-[38.400000000000006px] h-[38.400000000000006px] p-1 [border-width:1px] [border-style:solid] border-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground))] rounded-sm bg-background flex items-center justify-center [transition:all_0.3s] text-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground)_20%)] shadow-sm">
              Z
            </div>
            <div className="absolute left-[146.4px] top-[50%] transform-[translateY(-50%)] w-[38.400000000000006px] h-[38.400000000000006px] p-1 [border-width:1px] [border-style:solid] border-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground))] rounded-sm bg-background flex items-center justify-center [transition:all_0.3s] text-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground)_20%)] shadow-sm">
              X
            </div>
            {/* Bottom */}
            <div className="absolute left-8 -bottom-4 w-[44.800000000000004px] h-[38.400000000000006px] p-1 [border-width:1px] [border-style:solid] border-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground))] rounded-sm bg-background flex flex-col items-start justify-end z-100 [transition:all_0.3s] text-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground)_20%)] shadow-sm">
              <div className="h-2 w-8 rounded-lg [transition:0.3s_all] bg-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground)_20%)]" />
            </div>
            <div
              className={cn(
                "absolute left-[82.80000000000001px] -bottom-4 w-[44.800000000000004px] h-[38.400000000000006px] p-1 [border-width:1px] [border-style:solid] border-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground))] bg-background rounded-sm flex flex-col items-start justify-end z-100 [transition:all_0.3s]",
                !isHovering
                  ? "[animation-hover-color:color-mix(in_srgb,var(--border)_80%,var(--muted-foreground)_20%)]"
                  : "[animation-hover-color:color-mix(in_srgb,var(--border)_50%,var(--muted-foreground)_50%)]",
                "shadow-sm",
              )}
            >
              <div className="h-2 w-8 rounded-lg [transition:0.3s_all] bg-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground)_20%)]" />
            </div>
            <div
              className={cn(
                "absolute left-[133.60000000000002px] -bottom-4 w-[51.2px] h-[38.400000000000006px] p-1 [border-width:1px] [border-style:solid] border-[initial]",
                isHovering
                  ? "border-[color-mix(in_srgb,var(--border)_50%,var(--muted-foreground)_50%)]"
                  : "border-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground)_20%)]",
                "bg-background rounded-sm flex flex-col items-start justify-end z-100 [transition:all_0.3s]",
                !isHovering
                  ? "[animation-hover-color:color-mix(in_srgb,var(--border)_80%,var(--muted-foreground)_20%)]"
                  : "[animation-hover-color:color-mix(in_srgb,var(--border)_50%,var(--muted-foreground)_50%)]",
                "shadow-sm",
              )}
            >
              <div
                className={cn(
                  "h-2 w-8 rounded-lg [transition:0.3s_all]",
                  !isHovering
                    ? "bg-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground)_20%)]"
                    : "bg-[color-mix(in_srgb,var(--border)_50%,var(--muted-foreground)_50%)]",
                )}
              />
              <CommandIcon
                size="1em"
                style={{
                  position: "absolute",
                  top: 4,
                  right: 4,
                  color: !isHovering ? color1 : color2,
                  transition: "0.3s all",
                }}
              />
            </div>
          </>
        );
      },
      backgroundPattern: "dots",
    },
  };
}
